<template>
  <b-card
      :title="`${text}`"
      :img-src="`${assetUrl}${imgURL}`"
      :img-alt="`${text} image`"
      img-top
      tag="article"
      :style="sizeStyle"
      class="mb-2 text-center"
      @click="handleBlockClick"
  >
    <b-card-text>
    </b-card-text>
  </b-card>

</template>

<script>
import Board from "../../board";
export default {
  name: "Speak_Square",
  components: {
    Board
  },
  props: {
    block: {
      type: Object,
      default:() => { return {}}
    },
    assetUrl: {
      type: String,
      default:() => ''
    },
    isStd: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  beforeDestroy() {
    this.player.pause();
    this.player = null;
  },
  computed: {
    text(){
      //@Todo add default text
      if (this.isStd) {
        return this.block && this.block.text ? this.block.text : 'error';
      }
      return ''
    },
    imgURL(){
      //@Todo add default Images
      return this.block && this.block.imgURL ? this.block.imgURL : '';
    },
    audioURL(){
      //@Todo add default Audio
      return this.block && this.block.audioURL ? this.block.audioURL : '';
    },
    drillDownBoard(){
      return this.block && this.block.board ?  this.block.board : {};
    }
  },
  methods: {
    handleCommunicationClick() {
      this.player = new Audio(this.audioURL);
      //Play audio
      this.player.play();

      this.player.addEventListener("ended", (a) => {
        this.player.currentTimer = 0;
      });
    },
    handleBlockClick(){
      //drill down if necessary
      debugger;
      if (this.block.isCategory
          && this.block.board
          && this.block.board.blocks
          && Array.isArray(this.block.board.blocks)
          && this.block.board.blocks.length > 0 )
      {
        this.$emit('drill-down', this.drillDownBoard);
      }else{
        this.$emit('block-click', this.block);
        this.handleCommunicationClick();
      }
    }
  },
  data() {
    return {
      sizeStyle:this.isStd ?'max-width: 12rem;margin:10px; cursor:pointer;':
          'max-width: 2rem;max-height: 2rem; cursor:pointer;',
      drillDown: false,
      mainProps: { blank: true, blankColor: '#777',  class: 'm1' },
      player: null
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
